import React from "react";
import "./Offers.css";

function Offers(props) {
  const { className } = props;

  return (
    <div className={`offers-2 border-1px-sonic-silver ${className || ""}`}>
      <div className="offers-1 poppins-medium-tundora-10px">OFFERS</div>
    </div>
  );
}

export default Offers;
